import moment from 'moment'

const EST_TZ = 'America/New_York'

export const getUTCTime = (dateStr, timeStr, timezone = EST_TZ) => +moment.tz(`${dateStr}T${timeStr}`, timezone).utc()
export const getShortTimeZone = (fullTimeZone) => {
  try {
    const date = new Date()
    const shortTimeZone = date.toLocaleString('en-US', { timeZone: fullTimeZone, timeZoneName: 'short' }).split(' ').pop()
    return shortTimeZone
  } catch (error) {
    return ''
  }
}
